import PropTypes from "prop-types";
import React, { useState } from "react";

import {
  StickyPopup as UIStickyPopup,
  Button,
  ThemeSelector,
  Typography
} from "@theconversation/ui";

/**
 * The `StickyPopup` component represents promos that are rendered at the
 * "stuck" to a corner of the page.
 *
 * Like a less intrusive popup than a Dialog.
 */
function StickyPopup({ message, buttonText, onClick, onClose, theme }) {
  const [open, setOpen] = useState(true);

  const handleClose = () => {
    setOpen(false);
    onClose();
  };

  return (
    <ThemeSelector theme={theme}>
      <UIStickyPopup
        open={open}
        color="primary"
        onClose={handleClose}
        prominent
        dismissable
      >
        <Typography variant="h5">
          { message }
        </Typography>

        <Button variant="contained" onClick={onClick}>
          { buttonText }
        </Button>
      </UIStickyPopup>
    </ThemeSelector>
  );
}

StickyPopup.defaultProps = {
  buttonText: "Button",
  message: "Lorem ipsum",
  theme: "default",
};

StickyPopup.propTypes = {
  buttonText: PropTypes.string,
  message: PropTypes.string,
  onClick: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
  theme: PropTypes.string,
};

export default StickyPopup;
